import * as yup from 'yup';

import { FORM_FIELDS } from './constants';

export const schema = yup.object().shape({
  [FORM_FIELDS.RECIPIENT_NAME.name]: yup
    .string()
    .required('Recipient name is required')
    .max(25, 'Max character limit of 25'),
  [FORM_FIELDS.HEADLINE.name]: yup
    .string()
    .required('Card headline is required')
    .max(100, 'Max character limit of 100'),
  [FORM_FIELDS.DESIGN_ID.name]: yup
    .string()
    .required('Design selection is required'),
  [FORM_FIELDS.SENDER_NAME.name]: yup
    .string()
    .max(100, 'Max character limit of 100'),
});
